export async function syncWishlistAfterLogin(): Promise<void> {
  const { useWishlistStore } = await import("@/store/wishlistStore");
  await useWishlistStore.getState().syncWithApi();
}
